import {SOFT_NAV_STATE} from './states'

export function interceptNavigationUI() {
  if (typeof navigation === 'undefined') return
  if (typeof NavigateEvent === 'undefined') return
  if (typeof NavigateEvent.prototype?.intercept !== 'function') return

  document.addEventListener(SOFT_NAV_STATE.PROGRESS_BAR.START, () => {
    const navigationCompleted = new Promise(resolve => {
      document.addEventListener(SOFT_NAV_STATE.PROGRESS_BAR.END, resolve, {once: true})
    })

    function handleNavigate(navigationEvent: NavigateEvent) {
      if (!shouldIntercept(navigationEvent)) return
      navigationEvent.intercept({
        scroll: 'manual',
        async handler() {
          // when the progress bar completes, also complete the navigation interception, and cleanup the listener
          await navigationCompleted
          navigation.removeEventListener('navigate', handleNavigate)
        },
      })
    }

    // while the progress bar is running, we want to intercept all navigation events
    // this may be called more than once, so we can't use {once: true}
    navigation.addEventListener('navigate', handleNavigate)
  })
}

function shouldIntercept(e: NavigateEvent) {
  return (
    e.canIntercept &&
    // formData needs to be sent to the server
    !e.formData &&
    // let the browser handle downloads
    !e.downloadRequest &&
    // hashChanges are handled by the browser
    !e.hashChange
  )
}
